export class MessageHandler {
  static parsePayload(payload) {
    if (!payload) return '';
    try {
      const object = JSON.parse(payload);
      const bodyComponent = (object?.template?.components || []).find((c) => c.type === 'body');
      const headerComponent = ((object?.components ?? object?.template?.components) ?? []).find((c) => c.type === 'header');
      const media = (headerComponent?.parameters || []).find((p) => p.type === 'image' || p.type === 'video' || p.type === 'document');

      return {
        header: {
          link:
            media?.image?.link ??
            media?.video?.link ??
            media?.document?.link ??
            '',
          type: media?.type,
        },
        body: bodyComponent?.parameters,
      };
    } catch {
      return '';
    }
  }

  static templateToMessage(message) {
    const template = JSON.parse(JSON.parse(message.content));
    const header = template.find((c) => c.type === 'HEADER');
    const body = template.find((c) => c.type === 'BODY');
    const footer = template.find((c) => c.type === 'FOOTER');
    const button = template.find((c) => c.type === 'BUTTONS');
    const payload = this.parsePayload(message?.payload);
    return {
      header: header,
      payload: payload,
      body: body?.text,
      footer: footer?.text,
      buttons: button?.buttons ?? [],
    };
  }

  static parseContent(message: any): any {
        try {
            return message.content ? JSON.parse(message.content) : message.content;
        } catch {
            return message.content;
        }
  }

  static transformMessage(message) {
    switch (message.messageType) {
        case 'image':
        case 'audio':
        case 'video':
        case 'document':
            return message?.reply && (message?.contextType === 'text' || message?.contextType === 'button')
                ? message.content
                : this.parseContent(message);
        case 'template':
            return this.templateToMessage(message);
        case 'text':
            return ['image','document'].includes(message?.contextType)
                ? this.parseContent(message)
                : message.content;
        case 'interactive':
            return this.parseContent(message);
        default:
            return message.content;
    }
  }



  static parseDeliveryMsg = (message) => {
    if (!message) return '';
    try {
      return JSON.parse(message);
    } catch {
      return [{ title: 'Message failed to sent' }];
    }
  };

  static toMessage(m, internalMember, externalMember) {
    return {
      id: m.id,
      whatsAppMessageId: m.whatsAppMessageId,
      name: 'User 1',
      isExternal: m.waGroupMemberId === externalMember,
      image: m.waGroupMemberId === externalMember ? 'panda.jpg' : '',
      type: m.waGroupMemberId === internalMember ? 'sent' : 'receive',
      message: this.transformMessage(m),
      time: m.createdDate,
      deliveryStatus: this.deliveryStatus(m),
      deliveryMessage: m?.deliveryMessage,
      avatarColorCode: m.avatarColorCode,
      senderName: m.senderName,
      messageType: m.messageType,
      replyMsg: this.transformReplyMessage(m),
      messageContextId: m.messageContextId || null,
      reaction: m.reaction || null,
      receiverName: m.receiverName || null,
      contextType: m.contextType || null,
      originalMessageContext: m.originalMessageContext || null,
    };
  }

  static transformReplyMessage(message) {
    switch (message.messageType) {
      case 'image':
        return JSON.parse(message.reply);
      case 'audio':
        return JSON.parse(message.reply);
      case 'video':
        return JSON.parse(message.reply);
      case 'document':
        return JSON.parse(message.reply);
      case 'template':
        return JSON.parse(message.reply);
      case 'text':
        return message.reply;
      case 'interactive':
      return message?.flowResponse;
      // return JSON.parse(message.reply);
      default:
        return message.reply;
    }
  }

  static deliveryStatus(m) {
    if (m.statusFailed) return 'failed';
    if (m.statusRead) return 'read';
    if (m.statusDelivered) return 'delivered';
    if (m.statusSent) return 'sent';
    return 'pending';
  }
}
